import { useMemo } from "react";
import classes from "../integrationStyles.module.scss";

/**
 * 
 * @param {*} props
 * detail : string => object key of _details the field is part of
 * index : int => since _details is an array. This tells us to which this field belongs to
 * @returns 
 */
export const SelectField = (props) =>{
    const {fieldName, fieldConfig, onChange, detail, index, ...prop} = props;
    const handleFieldChange= (value, e) =>{
        if(onChange)
            onChange(value, fieldName, {fieldConfig, detail, index, e});
    }
    
    const settings = useMemo(() => {
        return {
            Mandatory : false, 
            Type : "select",
            Value : null, 
            ...fieldConfig
        }
    }, [fieldConfig])
    return (
        <>
        <select
            name={fieldName}
            required={settings.Mandatory}
            key={fieldName}
            defaultValue={settings.Value}
            className={classes["select1"]}
            {...prop}
            onChange={(e) => {
                handleFieldChange( e.target.value, e);
            }}
            placeholder={settings.Trans?.Placeholder || ""}
            >
                <option value={null} key={"0-null"}>
                {""}
                </option>
            {settings.ValidValues.map((value, index) => (
                <option value={value.Code} key={index}>
                {value.Code}
                </option>
            ))}
            </select>
        </>
    )
}